import { Intent, Spinner } from "@blueprintjs/core";
import Login from "components/Login";
import NeedVerify from "components/NeedVerify";
import { BUSY_GLOBAL, BusyTokens, selectBusyTokens } from "controllers/busy/action";
import {
  selectCurrentRoute,
  selectNotice,
  selectPreviousRoute,
  selectRoutes,
  setCurrentRoute,
  setPreviousRoute,
} from "controllers/common/action";
import { selectSamples } from "controllers/samples/action";
import { selectUser, selectLoginUserBusy } from "controllers/user/action";
import React, { Fragment, ReactNode } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router";
import { constructPath, RootProps } from "routes";
import { Analytics } from "utils/analytics";
import { parseBoolean } from "utils/utils";
import "./RouteBase.scss";

export interface RouteBaseProps extends RootProps {
  renderRoute: (props: RootProps) => ReactNode;
}

interface IProps extends RouteBaseProps {
  loginBusy: any;
  busyTokens: BusyTokens;
}

class Root extends React.Component<IProps> {
  componentDidMount() {
    const { node, page } = this.props;
    if (node.isLeaf()) {
      this.props.setCurrentRoute?.(page);
      Analytics.getInstance().pageview(constructPath(node));
    }
  }
  componentWillUnmount() {
    const { node, page } = this.props;
    if (node.isLeaf()) {
      this.props.setPreviousRoute?.(page);
    }
  }

  renderLoading() {
    return (
      <div className="global-loading">
        <Spinner intent={Intent.PRIMARY} />
      </div>
    );
  }

  render() {
    try {
      const { notice, user, loginBusy, busyTokens, page, renderRoute } = this.props;
      const globalBusy = Object.values(busyTokens || {}).filter((t) => t.type === BUSY_GLOBAL).length > 0;
      if (parseBoolean(process.env.REACT_APP_NOTICE as string) && !notice) {
        // return <Notice />;
      } else if (loginBusy) {
        return this.renderLoading();
      } else if (page.user && !user) {
        return <Login isOpen={true} goHome={true} />;
      } else if (page.user && user && !page.nonVerified && !user.emailVerified) {
        return <NeedVerify user={user} />;
      } else if (renderRoute) {
        return (
          <Fragment>
            {renderRoute(this.props)}
            {globalBusy && this.renderLoading()}
          </Fragment>
        );
      }
    } catch (error: any) {
      return <Navigate to={`/error?message=${error.message}`} />;
    }
  }
}

const mapStateToProps = (state: any) => ({
  notice: selectNotice(state),
  user: selectUser(state),
  routes: selectRoutes(state),
  currentRoute: selectCurrentRoute(state),
  previousRoute: selectPreviousRoute(state),
  loginBusy: selectLoginUserBusy(state),
  busyTokens: selectBusyTokens(state),
  samples: selectSamples(state),
});

const mapActionToProps = { setCurrentRoute, setPreviousRoute };

export default connect(mapStateToProps, mapActionToProps)(Root);
